import React from 'react';
import styled from 'styled-components';

import { AlertError, AlertWarning } from '@ad-scripts/presentation/components/common/alert';
import { useSelector } from 'react-redux';
import {
  selectAnon,
  selectExternalActionsErrors,
} from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';

const AlertsPanel = () => {
  const errors = useSelector(selectExternalActionsErrors);
  const anon = useSelector(selectAnon);

  if (!errors.length || anon) {
    return null;
  }

  const errs = errors.map((err, i) => {
    return (
      <>
        {err.code !== 'warning' ? (
          <StyledAlertError key={i}>
            <b>Error!</b> {err.detail}
          </StyledAlertError>
        ) : (
          <StyledAlertWarning key={i}>
            <b>Warning!</b> {err.detail}
          </StyledAlertWarning>
        )}
      </>
    );
  });

  return <>{errs}</>;
};

const StyledAlertError = styled(AlertError)`
  margin: 0 0 24px 0;
  max-width: 752px;
  width: inherit;
`;

const StyledAlertWarning = styled(AlertWarning)`
  margin: 0 0 24px 0;
  max-width: 752px;
  width: inherit;
`;

export default AlertsPanel;
